module.exports = __webpack_public_path__ + "media/packs/images/flags/WS-8f2b28a18d6a87b17030c439ed6408b3.svg";